import { mutations } from "Cart/store/mutations";

const actions = {
	addProductToCart({ commit }, payload) {
		commit(mutations.ADD_PRODUCT_TO_CART.name, payload);
	},
	removeProductFromCart({ commit }, id) {
		commit(mutations.REMOVE_PRODUCT_FROM_CART.name, id);
	},
	updateProductCount({ commit }, payload) {
		commit(mutations.UPDATE_PRODUCT_COUNT.name, payload);
	},
	clearCart({ commit }) {
		commit(mutations.CLEAR_CART.name, null);
	},
	getProduct({ state }, id) {
		return state.products.find(function (product) {
			return product.id === id;
		});
	},
	setComment({ commit }, comment) {
		commit(mutations.SET_COMMENT.name, comment);
	},
	setProductChecked({ commit }, id) {
		commit(mutations.SET_ITEM_CHECKED.name, id);
	},
	resetProductChecked({ commit }, id) {
		commit(mutations.RESET_ITEM_CHECKED.name, id);
	},
	removeCheckedItems({ commit }) {
		commit(mutations.REMOVE_CHECKED_ITEMS.name, null);
	}
};
export { actions };